import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Apple, Moon, BrainCircuit } from 'lucide-react';
const modules = [{
  range: 'Módulo 1-3',
  title: 'Entendiendo el Cortisol y la Grasa Abdominal',
  desc: 'Descubre por qué tu cuerpo almacena grasa de forma diferente ahora y cómo apagar la señal de estrés constante.',
  icon: <Activity size={28} className="text-sage-700" data-id="element-124" />
}, {
  range: 'Módulo 4-6',
  title: 'Nutrición Metabólica y Descanso Digestivo',
  desc: 'Aprende a comer para tus hormonas actuales sin pasar hambre. Estrategias simples para reactivar tu metabolismo.',
  icon: <Apple size={28} className="text-sage-700" data-id="element-125" />
}, {
  range: 'Módulo 7-9',
  title: 'El Manual del Sueño y Suplementación Global',
  desc: 'Protocolos exactos para volver a dormir de corrido y los suplementos clave que realmente marcan la diferencia.',
  icon: <Moon size={28} className="text-sage-700" data-id="element-126" />
}, {
  range: 'Módulo 10-15',
  title: 'Claridad Mental, Gestión Emocional y Plan de Acción',
  desc: 'Despídete de la neblina mental. Incluye tu plan paso a paso de 21 días para implementar todo sin abrumarte.',
  icon: <BrainCircuit size={28} className="text-sage-700" data-id="element-127" />
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ModulesSection() {
  return <section className="py-20 md:py-32 bg-cream-dark" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-130">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-131">
            Tu ruta clara hacia el bienestar
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-132">
            15 módulos diseñados estratégicamente para resultados reales.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-133">
          {modules.map((mod, index) => <motion.div key={index} variants={itemVariants} className="bg-cream rounded-2xl p-8 shadow-sm border border-sage-100 hover:border-sage-300 transition-colors flex flex-col sm:flex-row gap-6 items-start" data-id="element-134">
              <div className="flex-shrink-0 w-16 h-16 bg-sage-100 rounded-2xl flex items-center justify-center" data-id="element-135">
                {mod.icon}
              </div>
              <div data-id="element-136">
                <span className="text-sage-700 font-semibold text-sm tracking-wider uppercase mb-2 block" data-id="element-137">
                  {mod.range}
                </span>
                <h3 className="text-2xl font-bold mb-3 leading-tight" data-id="element-138">
                  {mod.title}
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-139">
                  {mod.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}